import { point2nest } from './functions'
import { OPERATION } from './handlers'
import {
  distrikt, isOptionalDistrikt, isValidDistrikt, setDistrikt
} from './hardcoded'
import {
  currentLayer, debug, i18n, locallyAr5, setAvailableLineAttributes
} from './storage'

const plus = import.meta.env.MODE === 'ar5web_pluss';
const arealbruk = ['arealtype', 'treslag', 'skogbonitet', 'grunnforhold'];

function addHiddenFormInput(form, column_id, column_value, classname) {
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const input = document.createElement('input');
  input.id = column_id;
  input.className = classname;
  input.value = column_value;
  input.type = 'hidden';
  div.appendChild(input);
  form.prepend(div);
}

export function addFormInput(
  form, list, attributeValues, id, header, help_url, dataType, classname
) {
  if (list) {
    addListInput(form, id, attributeValues, header, help_url, classname);
  } else {
    if (dataType === 'date') addDateInput(form, id, header, help_url);
    if (dataType === 'text') addTextInput(form, id, header, classname);
  }
}

function addDateInput(form, id, header, help_url) {
  const ny = form.id === 'info-box-drawnline-attributes-row';
  const label = ny ? header.replace('registrering', 'verifisering') : header;
  const fie = document.createElement('div');
  fie.className = 'form-input-element';
  const lbl = document.createElement('label');
  lbl.className = 'label-text';
  lbl.innerHTML = label + ':';
  const wb = document.createElement('div');
  wb.className = 'round-corners';
  const i = document.createElement('input');
  // i.id = id;
  i.name = id;
  i.type = 'date';
  i.className = 'datepicker';
  const today = new Date();
  const isoToday = today.toISOString().substring(0, 10); // yyyy-mm-dd
  // i.valueAsDate = new Date(); // today // did not work for webkit
  if (!locallyAr5) i.value = isoToday;
  else i.required = true;
  // i.min = '2000-01-01'; // if they want red style before starting changes
  i.max = isoToday; // today
  // i.pattern = '[0-3][1-9].[0-1][1-9].20[0-3][0-9]';
  // i.onchange = () => { console.log('onchange'); }; // did not work
  // i.oninvalid = () => { console.log('oninvalid'); }; // did not work
  i.oninput = () => {
    if (!i.checkValidity()) {
      if (i.validity.rangeUnderflow) {
        const min = i.min.split('-').reverse().join('.');
        i.setCustomValidity('Datoen må være ' + min + ' eller senere');
      } else if (i.validity.rangeOverflow) {
        const max = i.max.split('-').reverse().join('.');
        i.setCustomValidity('Datoen må være ' + max + ' eller tidligere');
      } else if (i.validity.badInput) {
        i.setCustomValidity('Datoen er ugyldig eller ufullstendig');
      } else i.setCustomValidity('');
    }
    i.title = i.validationMessage; // fix Chrome 86 bug
  };
  wb.appendChild(i);
  fie.appendChild(lbl);
  fie.appendChild(wb);
  form.appendChild(fie);
}

const tillatFlere = ['RVR_F', 'RSO_F', 'RHS_F', 'RHV_F', 'RVI_F', 'RDR_F'];

const flereDistrikt = s => {
  // console.log(s.options);
  const ul = document.createElement('ul');
  ul.id = 'flereDistrikt';
  s.forEach(o => {
    const li = document.createElement('li');
    const cb = document.createElement('input');
    cb.id = `cb${o.value}`
    cb.type = 'checkbox';
    cb.value = o.value;
    // cb.checked = o.selected;
    // cb.onchange is where we assign values (selected and changed are available)
    li.appendChild(cb);
    const l = document.createElement('label');
    l.htmlFor = cb.id;
    // l.innerHTML = `${o.value} (${o.innerHTML})`;
    l.innerHTML = `${o.value} (${o.display_value})`;
    // l.innerHTML = o.value;
    l.title = o.display_value;
    li.appendChild(l);
    const up = document.createElement('button');
    // up.innerHTML = '&uarr;';
    up.innerHTML = '&#9650;';
    up.onclick = () => {
      const previousSibling = li.previousElementSibling;
      if (previousSibling) ul.insertBefore(li, previousSibling);
      // Trigger update reinbeitebruker_id after reordering cb list:
      cb.dispatchEvent(new Event('change'));
    };
    li.appendChild(up);
    const down = document.createElement('button');
    // down.innerHTML = '&darr;';
    down.innerHTML = '&#9660;';
    down.onclick = () => {
      const nextSibling = li.nextElementSibling;
      if (nextSibling) ul.insertBefore(nextSibling, li);
      // Trigger update reinbeitebruker_id after reordering cb list:
      cb.dispatchEvent(new Event('change'));
    };
    li.appendChild(down);
    ul.appendChild(li);
  });
  if (s.length < 2) ul.hidden = true;
  return ul;
};

function addListInput(form, id, attributeValues, header, help_url, classname) {
  if (debug < 16) console.log('creating select:', id, attributeValues);
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const label = document.createElement('label');
  label.className = 'label-text';
  label.innerHTML = `${header}:`;
  if (header !== '') div.appendChild(label);
  const select = document.createElement('select');
  select.id = id;
  select.className = `form-control ${classname} ${id}`;
  const b2 = id.indexOf('bruker_id2') > -1;
  const b3 = id.indexOf('bruker_id3') > -1;
  const s2 = id === 'samebyid2';
  select.required = !(b2 || b3 || s2);
  div.appendChild(select);

  if (id === 'reinbeitebruker_id') setDistrikt(attributeValues);
  const appendNumber = arealbruk.indexOf(id) > -1;
  let init = false;
  if (attributeValues.length === 1)
    init = true; // select the only choice
  else {
    const o = document.createElement('option');
    o.value = '';
    o.selected = true;
    if (b2 || b3 || s2) o.innerHTML = 'Ikke spesifisert';
    else {
      o.disabled = true;
      o.hidden = true;
      o.innerHTML = 'Velg...';
    }
    if (!plus || appendNumber || id === 'klassifiseringsmetode')
      select.appendChild(o);
  }

  attributeValues.forEach(attribute => {
    const value = attribute.value;
    const displayed = (id.indexOf('reinbeitebruker') > -1) ?
      `${value} (${attribute.display_value})` : attribute['display_value'];
    const disabled = false && (value === 'dig');
    const toHide = (
      (isOptionalDistrikt(id) && !isValidDistrikt(value)) ||
      (!plus && id === 'datafangstmetode' && ['dig', 'sat'].indexOf(value) < 0) ||
      (!plus && id === 'klassifiseringsmetode' && ['uAnnen', 'uFjern'].indexOf(value) > -1)
    );
    if (displayed !== '') {
      const o = document.createElement('option');
      o.value = value;
      if (init) { o.selected = true; init = false; }
      o.disabled = disabled;
      o.hidden = toHide;
      o.innerHTML = displayed + (appendNumber ? ` (${value})` : '');
      select.appendChild(o);
    } else {
      if (attributeValues.length === 2) init = true;
    }
  });

  if ((distrikt.length === 1) && isOptionalDistrikt(id)) {
    if (debug < 5) console.log('distrikt:', distrikt, '(is optional)');
    return;
  }

  if (id.startsWith('reinbeitebr') && tillatFlere.indexOf(currentLayer.id) > -1)
    div.appendChild(flereDistrikt(attributeValues));

  form.append(div);

  // hide third field
  if (id.indexOf('reinbeitebruker_id3') > -1) {
    const sibling3 = form.getElementsByClassName('reinbeitebruker_id3')[0];
    sibling3.parentNode.style.display = 'none';
    const sibling2 = form.getElementsByClassName('reinbeitebruker_id2')[0];
    sibling2.addEventListener('change', () => {
      sibling3.parentNode.style.display = sibling2.value ? 'block' : 'none';
    });
  }
}

function addTextInput(form, id, header, classname) {
  if (debug < 10) { console.log('creating text input:', id, form); }
  const div = document.createElement('div');
  div.className = 'form-input-element';
  const label = document.createElement('label');
  label.htmlFor = id;
  label.className = 'label-text';
  label.innerHTML = header + ':';
  if (header) { div.appendChild(label); }
  const input = document.createElement('input');
  input.id = id;
  input.type = 'text';
  input.className = classname
  if (locallyAr5 && header.indexOf('informasjon') > -1) {
    const hint = 'Valgfritt – kun for viktige opplysninger';
    input.placeholder = hint;
    input.title = hint;
  }
  // input.onblur = () => {
  //   if (input.value) { console.log('Blurred, save', input.value); }
  // };
  div.appendChild(input);
  form.appendChild(div);
}

export function valueIsNotSelectable(v, s) {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    if (s.options[i].value === v.toString()) return false;
  }
  return true;
}

export function valueIsHidden(v, s) {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    const o = s.options[i];
    if (o.value === v.toString() && (o.hidden)) return true;
  }
  return false;
}

export const getIndexFromValue = (v, s) => {
  const l = s.length;
  for (let i = 0; i < l; i++) {
    const o = s.options[i];
    if (o.value === v?.toString()) return i;
  }
  return -1;
};

export const populatePreliminaryForm = (form, entities) => {
  // Delete all form elements
  form.innerHTML = '';

  // If there is no attributes then save the line automatically
  // when the user finishes the line
  // Default we set it to false and if there is one
  // columns that will be shown to the user, then we
  // set it to true
  setAvailableLineAttributes(false);
  entities.forEach(attribute => {
    const display = attribute['display_column'];
    const valuesEntities = attribute['prepareEditLayerResAttrValuesEntities'];
    if (display === 'yes'
      || (OPERATION === 'edit' && display === 'display_on_update')
      || (OPERATION !== 'edit' && display === 'display_on_add')
    ) {
      setAvailableLineAttributes(true);

      let list = false;
      const attributeChoices = new Array();

      const id = attribute['column_id'];
      const header = attribute['column_header_display'];
      // const name = attribute['column_name'];
      const help_url = attribute['column_help_url'];
      const dataType = attribute['column_datatype'];

      // Check if this attribute is a confined list
      if (valuesEntities.length > 0) {
        list = true;
        valuesEntities.forEach(attributeValue => {
          let a = {};
          a['display_value'] = attributeValue['column_display'];
          a['value'] = attributeValue['column_value'];
          attributeChoices.push(a);
        });
      }
      addFormInput(
        form, list, attributeChoices,
        id, header, help_url, dataType, 'form-line-attribute'
      );
    } else {
      let value = null;
      const id = attribute['column_id'];
      if (valuesEntities > 0) {
        const entity = valuesEntities[0];
        if (entity.hasOwnProperty('column_value')) {
          value = entity['column_value'];
        }
      }
      addHiddenFormInput(form, id, value, 'form-line-attribute');
    }
  });
};

export const setToday = (dateContainer) => {
  // name="verifiseringsdato" type="date" class="datepicker"
  const d = dateContainer.querySelector('.datepicker');
  if (d && d.name.indexOf('verifiseringsdato') > -1) {
    const today = new Date();
    const isoToday = today.toISOString().substring(0, 10); // yyyy-mm-dd
    if (d.value === isoToday) return;
    // d.valueAsDate = today; // did not work for webkit
    d.value = isoToday;
    d.dispatchEvent(new Event('change'));
  }
};

export const createAdvice = id => {
  const advice = i18n.advice[id];
  const ida = `${id}Advice`;
  const d = document.getElementById(ida) || document.createElement('details');
  if (advice) {
    d.id = ida;
    d.className = 'tips';
    d.innerHTML = advice.join(' ');
  } else d.hidden = true;
  return d;
};
